'use strict';

var d3 = require('d3');
var _ = require('lodash');
var PricingDepartureDatesChart = function PricingDepartureDatesChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartXAxis, chartYAxis, chartConstants, svgPatternService) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  function getEffectiveServicesYAxisMax(data) {
    var dataWithoutGaps = _.filter(data, ['isGap', false]);
    return d3.max(dataWithoutGaps, function (d) {
      return _.max(_.without([d.m3, d.m4, 0], undefined));
    });
  }
  function calculateEffectiveServicesTickValues(yMax) {
    var result = [];
    for (var i = 0; i <= yMax; i++) {
      result.push(i);
    }
    return result;
  }
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    svgPatternService.initPatterns(['user-exclusion', 'user-exclusion-viewport']);
    var dispatch = d3.dispatch('selectedDepartureDate');
    d3.rebind(this, dispatch, 'on');

    // chart components
    var groups = chartGroups('departureDateMoment', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var circles = chartCircles('circles');
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withoutLine();
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var yAxisRight = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.RIGHT);
    yAxisLeft.label('Services');
    yAxisRight.label('Average Effective Fare Change');
    yAxisRight.withLabelRotation(-90);
    var maxRangeSize;
    this.render = function (data, range) {
      this.initChart(data, this.getMaxRange(range), chartParams);
      this.scales = chartScales(this.params, this.data, this.visibleXRange, 'm1');
      this.secondaryScale = chartScales(this.params, this.data, this.visibleXRange, ['m3', 'm4'], this.scales);
      this.setMaxRangeSize();
      this.callForDataGroup([yAxisRight, groups, m1Bars, xAxis], this.scales);
      this.callForDataGroup([yAxisLeft, circles], this.secondaryScale);
      var yMax = getEffectiveServicesYAxisMax(data);
      if (yMax <= 5 && yMax !== 0) {
        yAxisLeft.withTickValues(calculateEffectiveServicesTickValues(yMax));
      } else {
        yAxisLeft.withTickValues(null);
      }
      this.callForYAxis(yAxisLeft, this.secondaryScale);
    };
    this.domainChange = function (range) {
      this.render(this.data, range);
    };
    this.setMaxRangeSize = function () {
      var maxWidth = 15 / 0.9; //group (bar + padding) width, refers to Scales.js:24
      var chartWidth = chartParams(this.container.width()).width;
      var newMaxRangeSize = Math.floor(chartWidth / maxWidth);
      if (newMaxRangeSize !== maxRangeSize) {
        maxRangeSize = newMaxRangeSize;
      }
    };
    this.getMaxRange = function (range) {
      if (typeof range === 'undefined') {
        return range;
      }
      this.setMaxRangeSize();
      var delta = range[1] - range[0];
      if (delta > maxRangeSize) {
        range[1] = range[0] + maxRangeSize;
      }
      return range;
    };
    this.getMaxRangeSize = function () {
      return maxRangeSize;
    };
    groups.on('groupclick', function (d, i) {
      dispatch.selectedDepartureDate(d, i);
    });
    this.withMetric = function (metric) {
      yAxisLeft.label(metric.label);
      return this;
    };
    container.on('$destroy', function () {
      groups.on('groupclick', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
PricingDepartureDatesChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsConstants', 'SvgPatternService'];
module.exports = PricingDepartureDatesChart;